import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectSidebar,
  setSidebar,
  toggleShow,
  toggleToShow,
} from '@app/redux/features/sidebarSlice';

function useSidebar() {
  const dispatch = useDispatch();
  const showSidebar = useSelector(selectSidebar);

  const toggleShowSidebar = () => {
    dispatch(toggleShow());
  };

  const toggleToShowSidebar = () => {
    dispatch(toggleToShow());
  };

  useEffect(() => {
    dispatch(setSidebar(showSidebar));
  }, [showSidebar]);

  return [showSidebar, toggleShowSidebar, toggleToShowSidebar] as const;
}

export default useSidebar;
